export default __webpack_public_path__ + "static/media/benefit_2@3x.4da0a06f.png";